import React, {Fragment, useState } from 'react';
import {Link, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {setAlert} from '../../actions/alert';
import {register2} from '../../actions/auth';
import {TFC_CENTER} from '../../Constant';

import PropTypes from 'prop-types';

const Register2 = ({ setAlert, register2, isAuthenticated }) => {

    const [formData, setFormData] = useState({
      username: '',      
      password: '',
      tfcname: TFC_CENTER.filter(l => l.key.toString() === "1").map(l => l.label)[0],
      tfccode: 1,
      ltype: ''
    });

    const { username, password, tfcname, ltype } = formData;

    if(isAuthenticated) {
      return <Redirect to='/dashboard' />
    } 

    const onSubmit = async e => {
      e.preventDefault();  
      console.log("on submit");  
      
      formData.tfccode = TFC_CENTER.filter(l => l.label.toString() === formData.tfcname.toString()).map(l => l.key)[0];      
      //console.log("tfc code: " + formData.tfccode);
      console.log(formData);
      register2(formData);              
    };

    /*if(isAuthenticated) {
      return <Redirect to='/dashboard' />
    } */   
    
    
    const onChange = e => {
      setFormData({ ...formData, [e.target.name] : e.target.value });  
      //name: e.target.value to change name alone
      //console.log(e.target.value);
    }

    return(
    <Fragment>
      <h1 className="text-primary badge-primary" style={{textAlign: "center"}}>Add Login for TFC</h1>      

      <form className="form" onSubmit = {e => onSubmit(e)} >

        <div className="form-group">    
          <small className="form-text">
            Enter User name
          </small>        
          <input type="text" placeholder="Name" value={username} 
              onChange = {e => onChange(e)} name="username" />
        </div>

        <div className = "form-group">
            <small className="form-text">
                Select TFC
            </small>
            <select name="tfcname" value={tfcname} onChange = {(e) => onChange(e)} >
              {TFC_CENTER.map(e => <option key = {e.key} value = {e.label}> {e.label} </option>)}
          </select>
          
        </div>


        <div className="form-group">
        <small className="form-text">
                Select Login Type
            </small>
                <select name="ltype" value={ltype} onChange={e => onChange(e)}>
                    <option value="0">* Select Type </option>
                    <option value="V">Verification</option>
                    <option value="U">Updation</option>
                    <option value="A">Attendance  </option>
                    <option value="C">Coordinator  </option>
                </select>
        </div>
      
        <div className="form-group">
        <small className="form-text">
            Enter Password
          </small>
        <input
            type="password" value={password} 
            placeholder="Password" onChange = {e => onChange(e)}
            name="password"
        
          />
        </div>             
      

      <input type="submit" className="btn btn-primary" value="Register" />
      </form>
      <p className="my-1">
        Already have an account? <Link to="/login">Sign In</Link>
      </p>
    </Fragment>
    )
};

Register2.propTypes = {
  setAlert: PropTypes.func.isRequired,
  register2: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool
};

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated
});

export default connect(
  mapStateToProps, 
  {setAlert, register2}
) (Register2); 